import * as React from 'react';

const QuantityItem = ({ className , label , subtext , aside  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: `${className}__quantity`
    }, /*#__PURE__*/ React.createElement("span", {
        className: `${className}__amount`
    }, label), subtext && /*#__PURE__*/ React.createElement("span", {
        className: `${className}__subtext`
    }, subtext)), aside && /*#__PURE__*/ React.createElement("span", {
        className: `${className}__aside`
    }, aside))
;

export { QuantityItem };
//# sourceMappingURL=QuantityItem.js.map
